import { atom } from "recoil"

export const interactionPreventionState = atom({
  key: "interactionPrevention",
  default: false,
})
